<ui-loader class="loader" *ngIf="loading"></ui-loader>

<div [class.loading]="loading">
  <div class="header">
    <div class="label-sm-semibold">
      {{ visualizationTopics | translate | titleCase }}
      <span class="label-xs note ml-2">{{ uncategorizedSignals | translate }}</span>
    </div>

    <ui2-button
      *ngIf="showResetData"
      class="button-icon reset-button"
      [title]="resetVisualization | translate | titleCase"
      (click)="resetData()"
    >
      <span class="icon2-x16-reset"> </span
    ></ui2-button>
  </div>

  <div uiHotspot="clusterVisualization">
    <chart-circle-packing-canvas
      class="circle-packing-canvas"
      [disableSelection]="true"
      [noData]="noData"
      [data]="data"
      [categoryKey]="insightsType.CATEGORY"
      (remove)="deselect($event)"
      (selectModelChange)="select($event)"
      (trackEvent)="trackEvent($event)"
    ></chart-circle-packing-canvas>
  </div>
</div>
